import { clearTokenPlatformCredentials } from '@/utils/token-platform-auth';

const ACCESS_TOKEN_STORAGE_KEY = 'wischoicer_access_token';
const TOKEN_TYPE_STORAGE_KEY = 'wischoicer_token_type';
const USER_ID_STORAGE_KEY = 'wischoicer_user_id';
const AGGREGATION_BASE_URL_STORAGE_KEY = 'wischoicer_aggregation_base_url';
const canUseStorage = () =>
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const getAccessToken = () => {
  if (!canUseStorage()) return '';
  return localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY) || '';
};

const decodeBase64Url = (value: string) => {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
  const padLength = (4 - (base64.length % 4)) % 4;
  const padded = `${base64}${'='.repeat(padLength)}`;

  if (typeof window === 'undefined' || typeof window.atob !== 'function') {
    return '';
  }

  return window.atob(padded);
};

const parseUserIdFromAccessToken = (accessToken: string) => {
  if (!accessToken) return '';

  const parts = accessToken.split('.');
  if (parts.length < 2) return '';

  try {
    const payload = decodeBase64Url(parts[1]);
    if (!payload) return '';
    const parsed = JSON.parse(payload);
    if (parsed?.sub === undefined || parsed?.sub === null) return '';
    return String(parsed.sub);
  } catch (_error) {
    return '';
  }
};

export const saveAuthToken = (accessToken: string, tokenType = 'Bearer') => {
  if (!canUseStorage()) return;
  localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, accessToken);
  localStorage.setItem(TOKEN_TYPE_STORAGE_KEY, tokenType);
};

export const saveAuthUserId = (userId: string | number) => {
  if (!canUseStorage()) return;
  localStorage.setItem(USER_ID_STORAGE_KEY, String(userId));
};

export const clearAuthToken = () => {
  if (!canUseStorage()) return;
  localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
  localStorage.removeItem(TOKEN_TYPE_STORAGE_KEY);
  localStorage.removeItem(USER_ID_STORAGE_KEY);
  localStorage.removeItem(AGGREGATION_BASE_URL_STORAGE_KEY);
  // WIS-496: 一并清除 token-platform (new-api) 凭证，防止跨账号串号泄漏
  clearTokenPlatformCredentials();
};

export const getAuthToken = () => {
  if (!canUseStorage()) return '';
  const accessToken = getAccessToken();
  if (!accessToken) return '';
  const tokenType = localStorage.getItem(TOKEN_TYPE_STORAGE_KEY) || 'Bearer';
  return `${tokenType} ${accessToken}`;
};

export const getAuthUserId = () => {
  if (!canUseStorage()) return '';

  const userId = localStorage.getItem(USER_ID_STORAGE_KEY);
  if (userId) return userId;

  const parsedUserId = parseUserIdFromAccessToken(getAccessToken());
  if (!parsedUserId) return '';
  localStorage.setItem(USER_ID_STORAGE_KEY, parsedUserId);
  return parsedUserId;
};

export const saveAggregationBaseUrl = (baseUrl?: string | null) => {
  if (!canUseStorage()) return;
  const normalized = (baseUrl || '').trim();
  if (!normalized) {
    localStorage.removeItem(AGGREGATION_BASE_URL_STORAGE_KEY);
    return;
  }
  localStorage.setItem(AGGREGATION_BASE_URL_STORAGE_KEY, normalized);
};

export const getAggregationBaseUrl = () => {
  if (!canUseStorage()) return '';
  return (
    localStorage.getItem(AGGREGATION_BASE_URL_STORAGE_KEY) || '/bff/execute'
  );
};
